import React from "react";
import { Link } from "react-router-dom";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFacebook } from "@fortawesome/free-brands-svg-icons";
import { faInstagram } from "@fortawesome/free-brands-svg-icons";
import { faTwitter } from "@fortawesome/free-brands-svg-icons";
import { faLinkedinIn } from "@fortawesome/free-brands-svg-icons";
import { faYoutube } from "@fortawesome/free-brands-svg-icons";
import { faSpotify } from "@fortawesome/free-brands-svg-icons";
import { Container } from "react-bootstrap";

/* Logo ---------------------------*/
import logo from "./../assets/images/WCPE_logo_white-01.svg";

const Footer = () => {
  return (
    <footer>
      <Container fluid>
        <div className="row">
          <div className="col-12 col-md text-white mb-3">
            <p>&copy; 2026 Western CPE LLC | All Rights Reserved</p>
          </div>
          <div className="col-12 col-md mb-3">
            <Link to="/">
              <img
                src={logo}
                width="150"
                className="footerImg"
                alt="Western CPE LOGO"
              />
            </Link>
          </div>
          <div className="col-12 col-md">
            <div className="social-media-icons-white row  justify-content-md-end  no-gutters">
              <div className="col d-none d-md-block"></div>
              <div className="col col-md-2 col-lg-1 g-0">
                <a
                  href="https://www.facebook.com/TheWesternCPE/"
                  target="_BLANK"
                >
                  <FontAwesomeIcon icon={faFacebook} />
                </a>
              </div>
              <div className="col col-md-2 col-lg-1 g-0">
                <a
                  href="https://www.instagram.com/thewesterncpe/"
                  target="_BLANK"
                >
                  <FontAwesomeIcon icon={faInstagram} />
                </a>
              </div>
              <div className="col col-md-2 col-lg-1 g-0">
                <a href="https://twitter.com/westerncpe" target="_BLANK">
                  <FontAwesomeIcon icon={faTwitter} />
                </a>
              </div>
              <div className="col col-md-2 col-lg-1 g-0">
                <a
                  href="https://www.linkedin.com/company/westerncpe/mycompany/"
                  target="_BLANK"
                >
                  <FontAwesomeIcon icon={faLinkedinIn} />
                </a>
              </div>
              <div className="col col-md-2 col-lg-1 g-0">
                <a
                  href="https://www.youtube.com/channel/UCpC5c8uWYBluQ280k2CTVNA"
                  target="_BLANK"
                >
                  <FontAwesomeIcon icon={faYoutube} />
                </a>
              </div>
              <div className="col col-md-2 col-lg-1 g-0">
                <a
                  href="https://open.spotify.com/show/5i3XlNp24xJW19bkTardFc?si=acbcd60bc31b480f"
                  target="_BLANK"
                >
                  <FontAwesomeIcon icon={faSpotify} />
                </a>
              </div>
            </div>
          </div>
        </div>
      </Container>
    </footer>
  );
};
export default Footer;
